import { MAT_DATE_FORMATS } from '@angular/material/core';
import { NATIVE_DATE_FORMATS } from './native-date-formats';

export const NativeDateFormatsProvider = {
  provide: MAT_DATE_FORMATS,
  useValue: NATIVE_DATE_FORMATS,
};
